import { useCallback, useState } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

export interface DepartmentGlCode {
  id: number;
  code: string;
  description: string;
  name: string;
  selected: boolean;
  isDirty: boolean;
  isDeleted: boolean;
  departmentName?: string;
  rowId: string;
}
export interface DepartmentMembers {
  id: number;
  name: string;
  isDeleted: boolean;
  selected: boolean;
  isDirty: boolean;
  rowId: string;
}
export interface Department {
  rowId: string;
  departmentId: number;
  name: string;
  editedName?: string;
  glCodes: DepartmentGlCode[];
  members: DepartmentMembers[];
  id: number;
  selected?: boolean;
  isDeleted?: boolean;
  isNewDepartmentName?: boolean;
}

export interface DepartmentResponse {
  buId: string;
  departments: Department[];
}

const useGetDepartmentApi = (companyId: string) => {
  const [departments, setDepartments] = useState<Department[]>([]);

  const call = useCallback(async () => {
    try {
      const res = await axiosInstance.get<DepartmentResponse>(api.department(companyId));
      const data: Department[] = res.data?.departments.map((item) => ({
        ...item,
        selected: false,
        rowId: uuid(),
        editedName: item.name,
        members: item.members.map((member) => ({
          ...member,
          selected: false,
          isDirty: false,
          rowId: uuid(),
        })),

        glCodes: item.glCodes.map((glCode) => ({
          ...glCode,
          name: `${glCode.code} ${glCode.description}`,
          selected: false,
          isDirty: false,
          rowId: uuid(),
        })),
      }));
      setDepartments(data);
      return { departments: data, buId: res.data.buId };
    } catch (error) {
      throw new Error(error);
    }
  }, [companyId]);

  const { isLoading, value, execute } = useAsync(call, false, undefined, {} as DepartmentResponse);

  return {
    isDepartmentLoading: isLoading,
    departments,
    setDepartments,
    getDepartments: execute,
    originalDepartments: value.departments,
    buId: value.buId,
  };
};

export default useGetDepartmentApi;
